import apiRequest from "@services/apiRequest";
import { useState } from "react";
import useAsyncError from "@hooks/useAsyncError";

export const useCheckMailExistence = () => {

  // hooks
  const throwError = useAsyncError();

  // state
  const [loading, setLoading] = useState(false);

  // handlers
  const check = async (email: string) => {
    setLoading(true);
    try {
      const result = await apiRequest.get("/users/check", {params: {email}});
      return result as unknown as {
        has_pending_invitation: boolean,
        has_registered_user: boolean,
        fullname?: string,
      };
    }
    catch (e) {
      throwError(e);
      return null;
    }
    finally {
      setLoading(false);
    }
  }

  return {loading, check};

}